module.exports = __webpack_public_path__ + "img/jianzhu_zhizhao.989f24bc.jpg";